<template>
  <div :class="{'hidden':hidden}" class="pagination-container">
    <el-pagination
      :background="background"
      :current-page.sync="pageCurrent"
      :page-size.sync="pageSize"
      :layout="layout"
      :page-sizes="pageSizes"
      :total="total"
      v-bind="$attrs"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
    <!-- v-bind="$attrs" 可以渲染上props未注册的属性 例如组件外添加 :dd="1" 这里可以接收-->
  </div>
</template>

<script>
// import { scrollTo } from '@/utils/scroll-to'

export default {
  name: 'Pagination',
  props: {
    total: {//总条数
      required: true,
      type: Number
    },
    currentPage: {// 当前页码
      type: Number,
      default: 1
    },
    limit: {//每页条数
      type: Number,
      default: 10
    },
    pageSizes: {//每页展示条数
      type: Array,
      default() {
        return [10, 20, 30, 50, 100]
      }
    },
    layout: {// 需要展示的子组件，默认展示完整功能
      type: String,
      default: 'total, sizes, prev, pager, next, jumper'
    },
    background: { // 是否需要背景色
      type: Boolean,
      default: false
    },
    autoScroll: {// 滚动条自动
      type: Boolean,
      default: true
    },
    hidden: { // 是否展示
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
    }
  },
  computed: {
    pageCurrent: {//监听 页码的变动，然后设置父组件的页码值 父组件使用.sync的修饰符
      get() {
        return this.currentPage
      },
      set(val) {
        this.$emit('update:currentPage', val)
      }
    },
    pageSize: {//监听 每页展示条数的变动，然后设置父组件的条数 父组件使用.sync的修饰符
      get() {
        return this.limit
      },
      set(val) {
        this.$emit('update:limit', val)
      }
    }
  },
  methods: {
    /**
     * @description 每页展示条数变动回调
     */
    handleSizeChange(val) {
      this.$emit('pagination', { page: 1, limit: val })
      // if (this.autoScroll) {
      //   scrollTo(0, 800)
      // }
    },

    /**
     * @description 页码变动回调
     */
    handleCurrentChange(val) {
      this.$emit('pagination', { page: val, limit: this.pageSize })
      // if (this.autoScroll) {
      //   scrollTo(0, 800)
      // }
    }
  }
}
</script>

<style lang="scss" scoped>
.pagination-container {
  background: #fff;
  padding: 32px 16px;
}
.pagination-container.hidden {
  display: none;
}
</style>
